import { useRef, useState, type PointerEvent, type ReactNode } from "react";
export function SwipeDeleteRow({ name, onDelete, children, actionLabel = "Удалить", showMenu = true }: { actionLabel?: string; showMenu?: boolean; name: string; onDelete?: (() => void) | undefined; children: ReactNode }) {
  const [offset, setOffset] = useState(0);
  const gesture = useRef<{ id: number; x: number; y: number; base: number; horizontal: boolean | null } | null>(null);
  const suppress = useRef(false);
  const start = (event: PointerEvent<HTMLDivElement>) => {
    if (event.button !== 0) return;
    suppress.current = false;
    gesture.current = { id: event.pointerId, x: event.clientX, y: event.clientY, base: offset, horizontal: null };
  };
  const move = (event: PointerEvent<HTMLDivElement>) => {
    const current = gesture.current;
    if (!current || current.id !== event.pointerId) return;
    const dx = event.clientX - current.x, dy = event.clientY - current.y;
    if (current.horizontal === null && Math.max(Math.abs(dx), Math.abs(dy)) > 7) current.horizontal = Math.abs(dx) > Math.abs(dy);
    if (!current.horizontal) return;
    event.preventDefault(); suppress.current = true;
    event.currentTarget.setPointerCapture(event.pointerId);
    setOffset(Math.max(0, Math.min(82, current.base + dx)));
  };
  const finish = (event: PointerEvent<HTMLDivElement>) => {
    const current = gesture.current;
    if (!current || current.id !== event.pointerId) return;
    gesture.current = null;
    if (current.horizontal) setOffset(event.type !== "pointercancel" && current.base + event.clientX - current.x >= 38 ? 82 : 0);
    // Capture the synthesized click following the drag, but not a later keyboard click.
    window.setTimeout(() => { suppress.current = false; }, 0);
  };
  if (!onDelete) return <>{children}</>;
  return <div className="swipe-delete-row" onPointerDown={start} onPointerMove={move} onPointerUp={finish} onPointerCancel={finish}>
    <button type="button" className="swipe-delete-trash" aria-label={`${actionLabel} ${name}`} tabIndex={offset ? 0 : -1} onPointerDown={event => event.stopPropagation()} onClick={onDelete}><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" /></svg>{actionLabel}</button>
    <div className="swipe-delete-content" style={{ transform: `translateX(${offset}px)` }} onClickCapture={event => { if (suppress.current) { event.preventDefault(); event.stopPropagation(); } }}>{children}{showMenu && <button type="button" className="swipe-delete-menu" aria-label={`Действия: ${name}`} onClick={() => setOffset(offset ? 0 : 82)}>⋯</button>}</div>
  </div>;
}
